import { useQuery } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import PaginateCard from "../../../../components/PaginateCard";
import PrintLink from "../../../../components/Shipment/Factor/PrintLink";
import { getByAuthService } from "../../../../function/helper";
import dateTimeToJalali from "../../../../function/jalali/dateTimetoJalali";
import Laoder from "../../../../modules/pages/newLetter/Loader";

function CodFlowList() {
  const [paginate, setPaginate] = useState({
    page: 1,
    items: 10,
  });

  const { data, isFetching, refetch } = useQuery({
    queryKey: ["agent-cod-list"],
    queryFn: () =>
      getByAuthService("/myaccount/v1/codFlow/getList", {
        page: paginate.page,
        items: paginate.items,
      }).then(res => {
        if (res.status === 200) {
          return res.data.result;
        }
      }),

    initialData: { user: { id: 0, codFlow: 0 }, list: [] },
    refetchOnWindowFocus: false,
    enabled: false,
  });

  useEffect(() => {
    refetch();
  }, [paginate.page]);

  return (
    <div>
      <div>
        <h5>موجودی مبالغ بستانکاری COD</h5>
        <p>
          <strong className="fs-4 text-success">
            {data.user.codFlow.toLocaleString()}
          </strong>
          <span> ریال</span>
        </p>
      </div>

      <div className="w-100 px-1 overflow-x-auto mt-5">
        <Table
          striped={true}
          bordered={true}
          className="align-middle"
          style={{ minWidth: 700 }}
        >
          <thead>
            <tr>
              <th>ردیف</th>
              <th>شماره سفارش</th>
              <th>مقدار</th>
              <th>موجودی</th>
              <th>واریز/برداشت</th>
              <th>توضیحات</th>
              <th>کد رهگیری</th>
              <th>تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {isFetching && (
              <tr>
                <td colSpan={8}>
                  <Laoder />
                </td>
              </tr>
            )}

            {!isFetching &&
              data.list.map((item, idx) => (
                <tr key={item.id}>
                  <td>{idx + 1 + (paginate.page - 1) * paginate.items}</td>
                  <td>
                    <PrintLink ids={[item.totalPostId]}>
                      {item.numberParcel}
                    </PrintLink>
                  </td>
                  <td>{item.amount.toLocaleString()}</td>
                  <td>{item.codFlow.toLocaleString()}</td>
                  <td>{item.isDeposit ? "واریز" : "برداشت"}</td>
                  <td>{item.description}</td>
                  <td>{item.trackingCode}</td>
                  <td>{dateTimeToJalali(item.created_at).full}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>

      <div className="mt-4">
        <PaginateCard
          count={data?.count}
          numberItems={paginate.items}
          numberPage={paginate.page}
          onIndexChoose={number =>
            setPaginate(cur => ({ ...cur, page: number }))
          }
        />
      </div>
    </div>
  );
}

export default CodFlowList;
